export default __webpack_public_path__ + "static/media/yessie.e43df02a.png";